import { createContext } from "react";

import { SuiQueryContextType } from "./SuiQueryContext.types";

export const SuiQueryContext = createContext<SuiQueryContextType | undefined>(undefined);
